import React from 'react';
import PropTypes from 'prop-types';
import StyledSvg from '../styledSvg';

const IconMarche = ({ color, size }) => (
  <StyledSvg fill={color} size={size} viewBox="0 0 38 48" xmlns="http://www.w3.org/2000/svg">
<g fill="#B68962" fill-rule="nonzero"><path d="M33.778 43.556V.889a.889.889 0 0 0-.89-.889h-32A.89.89 0 0 0 0 .889v42.667c0 .491.398.888.889.888h32a.888.888 0 0 0 .889-.888zM32 42.666H1.778V1.779H32v40.889z"/><path d="M36.444 3.556a.889.889 0 0 0-.888.888v41.778H2.666a.889.889 0 1 0 0 1.778h33.778a.888.888 0 0 0 .89-.889V4.444a.889.889 0 0 0-.89-.888z"/><path d="M22.222 13.845v4.822a.889.889 0 1 0 1.778 0v1.777a.889.889 0 1 0 1.778 0v-6.599a4.447 4.447 0 0 0 2.666-4.067A4.45 4.45 0 0 0 24 5.333a4.45 4.45 0 0 0-4.444 4.445c0 1.818 1.1 3.38 2.666 4.067zM24 7.111a2.67 2.67 0 0 1 2.667 2.667A2.67 2.67 0 0 1 24 12.444a2.67 2.67 0 0 1-2.667-2.666A2.67 2.67 0 0 1 24 7.11zM6.222 8.889h8.89a.89.89 0 0 0 0-1.778h-8.89a.89.89 0 0 0 0 1.778zM6.222 12.444h8.89a.89.89 0 0 0 0-1.777h-8.89a.89.89 0 0 0 0 1.777zM6.222 16h8.89a.89.89 0 0 0 0-1.778h-8.89a.89.89 0 0 0 0 1.778zM6.222 26.667h21.334a.888.888 0 1 0 0-1.778H6.222a.889.889 0 1 0 0 1.778zM6.222 30.222h21.334a.888.888 0 1 0 0-1.778H6.222a.889.889 0 1 0 0 1.778zM22.222 37.333H11.556a.889.889 0 1 0 0 1.778h10.666a.888.888 0 1 0 0-1.778zM12.84 36.83c.5 0 .982-.313 1.402-.695.114.096.245.179.396.243.806.348 1.404-.026 1.81-.498.078.004.158 0 .238-.017.205-.043.4-.099.592-.156l.104-.03c.274.217.596.317.814.385.109.035.337.106.36.146a.89.89 0 0 0 1.555-.86c-.368-.665-1.006-.864-1.387-.982l-.158-.05a.882.882 0 0 0-.914-.514c-.168.02-.328.053-.478.09a.892.892 0 0 0-.51-.45.894.894 0 0 0-1.06.406c-.047.082-.097.183-.153.294l-.038.076a.887.887 0 0 0-1.513-.334l-.19.22c-.164.191-.624.727-.89.91a.888.888 0 0 0-.596 1.645c.206.12.412.171.616.171z"/></g>
  </StyledSvg>
);

IconMarche.propTypes = {
  /** Should be a valid css color in a string */
  color: PropTypes.string,
  /** Should be a the value in px */
  size: PropTypes.number,
};

IconMarche.defaultProps = {
  color: '#000',
  size: 50,
};

export default IconMarche;



// WEBPACK FOOTER //
// ./src/app/components/icons/IconMarche.jsx